import { useState } from "react";

const PASSWORD = "-Pd2&7848VoO";

export default function PasswordGate({ children }) {
  const [unlocked, setUnlocked] = useState(
    () => sessionStorage.getItem("unlocked") === "true"
  );
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === PASSWORD) {
      sessionStorage.setItem("unlocked", "true");
      setUnlocked(true);
    } else {
      setError(true);
      setInput("");
    }
  };

  if (unlocked) return children;

  return (
    <div className="gate-overlay">
      <form className="gate-box" onSubmit={handleSubmit}>
        <p className="gate-emoji">💌</p>
        <p className="gate-title">This is a private message</p>
        <p className="gate-subtitle">Enter the password to continue</p>
        <input
          className="gate-input"
          type="password"
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
            setError(false);
          }}
          placeholder="Password"
          autoFocus
        />
        {error && <p className="gate-error">Incorrect password</p>}
        <button className="gate-button" type="submit">
          Open
        </button>
      </form>
    </div>
  );
}
